export default "__VITE_ASSET__XNvobD8x__"